export default function ApiKeysPage() {
  return (
    <div className="card p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">API Keys</h2>
      <p className="text-gray-500">API key management coming soon...</p>
    </div>
  );
}
